import React from "react";
import { Link } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Horikawa from "../image/toyama_horikawa.png";
import Takaoka from "../image/toyama_takaoka.png";
import Tonami from "../image/toyama_tonami.png";
import Komatsu from "../image/ishikawa_komatsu.png";
import Ishikawa from "../image/ishikawa_ishikawa.png";
import Fukui from "../image/fukui_fukui.png";
import Mutsukawa from "../image/yokohama_mutsukawa.png";
import { Reveal, SectionHeading, FloatingDecor, Sprout, Breadcrumb, PageMeta } from "./tht/ThtParts";
import "./tht/ThtTop.css";
import "./tht/ThtDesign.css";
import "./tht/ThtBusiness.css";
import "./tht/ThtClass.css";
import "./tht/ThtNatural.css";


// 各教室のページは別タブで開く(教室のサイト内を見て回った後でも、このタブでTHTのサイトにすぐ戻れるように)
const NEW_TAB = { target: "_blank", rel: "noopener noreferrer" } as const;

const Class = () => {
  const meta = {
    title: "教室一覧 - 土日だけ体操教室｜体操教室・バク転・体幹強化",
    description:
      "富山県（堀川・高岡・砺波）、石川県（小松・金沢鳴和）、福井県、神奈川県（横浜六ツ川）で展開する「土日だけ体操教室」全7教室の一覧。住所・料金・無料体験の申込みは各教室ページから確認できます。",
    canonical: "https://tht-group.co.jp/class",
    meta: {
      charset: "utf-8",
      name: {
        keywords: [
          "土日だけ体操教室",
          "富山体操教室",
          "石川体操教室",
          "福井体操教室",
          "バク転",
          "バク転教室",
          "パーソナル教室",
          "体操式メニュー",
          "体操教室",
          "体幹・体づくり教室",
          "柔軟性",
          "体幹",
          "瞬発力",
          "成長フィードバック",
          "マット運動",
          "跳び箱",
          "鉄棒",
          "トランポリン",
          "少人数制",
          "挑戦",
          "成功",
          "無料体験",
          "体験レッスン",
        ].join(","),
      },
    },
  };

  const areas = [
    {
      region: "北信越エリア",
      prefectures: [
        {
          name: "富山県",
          shops: [
            {
              name: "富山市 堀川店",
              address:
                "〒939-8072 富山県富山市堀川町 355-7 マイプラザ2F（ダイソー前）",
              phone: "donichidaketaisou@gmail.com ", //939-8005
              image: Horikawa,
              text: "教室の詳細ページへ",
              rout: "/horikawa",
            },
            {
              name: "高岡市 高岡店",
              address: "〒933-0042 富山県高岡市中川栄町６−１０",
              phone: "donichidaketaisou@gmail.com ", //939-8005
              image: Takaoka,
              text: "教室の詳細ページへ",
              rout: "/takaoka",
            },
            {
              name: "砺波市 砺波店",
              address: "〒939-1328 富山県砺波市大辻７１４",
              phone: "donichidaketaisou@gmail.com ", //939-8005
              image: Tonami,
              text: "教室の詳細ページへ",
              rout: "/tonami",
            },
            // 他のショップを追加
          ],
        },
        {
          name: "石川県",
          shops: [
            {
              name: "小松市 小松店",
              address: "〒923-0804 石川県小松市光町４７",
              phone: "donichidaketaisou@gmail.com ", //939-8005
              image: Komatsu,
              text: "教室の詳細ページへ",
              rout: "/komatsu",
            },
            {
              name: "石川県 石川店",
              address: "〒920-0804 石川県金沢市鳴和２丁目１０−４４",
              phone: "donichidaketaisou@gmail.com ", //939-8005
              image: Ishikawa,
              text: "教室の詳細ページへ",
              rout: "/ishikawa",
            },
            // 他のショップを追加
          ],
        },
        {
          name: "福井県",
          shops: [
            {
              name: "福井市 福井店",
              address:
                "〒910-0015 福井県福井市二の宮３丁目４２−１２ ジョイライフ",
              phone: "donichidaketaisou@gmail.com ", //939-8005
              image: Fukui,
              text: "教室の詳細ページへ",
              rout: "/fukui",
            },
            // 他のショップを追加
          ],
        },
      ],
    },
    {
      region: "関東エリア",
      prefectures: [
        {
          name: "神奈川県",
          shops: [
            {
              name: "横浜市 南区六ツ川店",
              address:
                "〒232-0066 神奈川県横浜市南区六ツ川４丁目1142-1F 第１笠原ビル",
              phone: "donichidaketaisou@gmail.com ", //939-8005
              image: Mutsukawa,
              text: "教室の詳細ページへ",
              rout: "/mutsukawa",
            },
            // 他のショップを追加
          ],
        },
      ],
    },
    // 他のエリアを追加
  ];

  return (
    <>
      <PageMeta {...meta} />
      <MotionConfig reducedMotion="user">
        <div className="tht-home biz cls">
          {/* ページの見出し */}
          <section className="biz-hero">
            <FloatingDecor />
            <div className="content-container">
              <Breadcrumb
                items={[
                  { label: "業務内容", to: "/business" },
                  { label: "教室一覧" },
                ]}
              />
              <SectionHeading en="Classroom" ja="教室一覧" />
              <Reveal delay={0.1}>
                <p className="lead-text">
                  THT合同会社が運営する「土日だけ体操教室」は、
                  <br className="pc-only" />
                  富山・石川・福井・神奈川の全7教室で開講しています。
                  <br />
                  教室の詳細や無料体験のお申し込みは、各教室のページからどうぞ。
                </p>
              </Reveal>
              {/* 都道府県へのページ内リンク */}
              <Reveal delay={0.2}>
                <nav className="biz-anchors">
                  {areas.flatMap((area) =>
                    area.prefectures.map((p) => (
                      <a
                        key={p.name}
                        href={`#${p.name}`}
                        onClick={(e) => {
                          e.preventDefault();
                          document.getElementById(p.name)?.scrollIntoView({ behavior: "smooth", block: "start" });
                        }}
                      >
                        <Sprout className="cls-anchor-sprout" />
                        {p.name}
                      </a>
                    ))
                  )}
                </nav>
              </Reveal>
            </div>
          </section>

          {areas.map((area) => (
            <section key={area.region} className="biz-section cls-area">
              <div className="content-container">
                <Reveal className="cls-region" x={-48} y={0}>
                  <span>{area.region}</span>
                </Reveal>
                {area.prefectures.map((prefecture) => (
                  <div key={prefecture.name} id={prefecture.name} className="cls-pref">
                    <Reveal x={-48} y={0}>
                      <h2 className="cls-pref-title">
                        <Sprout className="cls-pref-sprout" />
                        {prefecture.name}
                      </h2>
                    </Reveal>
                    <div className="cls-grid">
                      {prefecture.shops.map((shop, i) => (
                        <Reveal key={shop.rout} delay={0.08 * i}>
                          <article className="cls-card">
                            <Link to={shop.rout} className="cls-card-img" {...NEW_TAB}>
                              <img src={shop.image} alt={shop.name} loading="lazy" />
                            </Link>
                            <div className="cls-card-body">
                              <h3>{shop.name}</h3>
                              <p className="cls-card-address">
                                <span>住所</span>
                                {shop.address}
                              </p>
                              <div className="cls-card-actions">
                                <Link to={shop.rout} className="tht-btn btn-orange" {...NEW_TAB}>
                                  教室の詳細 <span>&rarr;</span>
                                </Link>
                                <Link to={`${shop.rout}/join`} className="cls-trial" {...NEW_TAB}>
                                  無料体験
                                </Link>
                              </div>
                            </div>
                          </article>
                        </Reveal>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </section>
          ))}

          <section className="biz-next">
            <Reveal className="content-container">
              <p>教室選びに迷ったら、お気軽にご相談ください。</p>
              <Link to="/contact" className="tht-btn btn-orange">
                お問い合わせ <span>&rarr;</span>
              </Link>
            </Reveal>
          </section>
        </div>
      </MotionConfig>
    </>
  );
};

export default Class;
